import {
  createFileRoute,
  Link,
  Outlet,
} from "@tanstack/react-router"
import { z } from "zod"
import { cn } from "@/lib/utils"

const resultsSearchSchema = z.object({
  quarterId: z.string().optional(),
  week: z.string().optional(),
  division: z.string().optional(),
  topic: z.string().optional(),
})

export const Route = createFileRoute("/(app)/app/results")({
  component: ResultsLayout,
  validateSearch: (search) => resultsSearchSchema.parse(search),
})

const NAV_ITEMS = [
  { label: "Daily", to: "/app/results/daily" },
  { label: "Specialist", to: "/app/results/specialist" },
  { label: "Pairs", to: "/app/results/pairs" },
  { label: "Teams", to: "/app/results/teams" },
  { label: "Champions", to: "/app/results/champions" },
] as const

function ResultsLayout() {
  const search = Route.useSearch()

  return (
    <div className="py-8 max-w-6xl">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Results</h1>
      </div>

      {/* Navigation */}
      <nav className="flex gap-1 border-b mb-6">
        {NAV_ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            search={search}
            className={cn(
              "px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
              "hover:text-foreground hover:border-border"
            )}
            activeProps={{
              className: "border-primary text-foreground",
            }}
            inactiveProps={{
              className: "border-transparent text-muted-foreground",
            }}
          >
            {item.label}
          </Link>
        ))}
      </nav>

      {/* Child Route Content */}
      <Outlet />
    </div>
  )
}
